import React from 'react';
import moment from 'moment';

export default class ReminderRow extends React.Component {
  render() {
    const {rowData, index, removeFromList, openModalReminder, action, status} = this.props;
    let buttonAction=null;

    if(action === 'add') {
      buttonAction = <button className="btn btn-link apple-red" onClick={()=>removeFromList(index)}><i className="icon-trash"></i></button>;
    } else {
      buttonAction = <button className="btn btn-link apple-green" onClick={()=>openModalReminder(rowData)}><i className="icon-pencil"></i></button>;
    }
  
    return (
      <tr>
        <td>{rowData.Method}</td>
        <td>{rowData.Email === '' ? '-' : rowData.Email}</td>
        <td>{rowData.Mobile === '' ? '-' : rowData.Mobile}</td>
        <td>{moment(rowData.Time).format('lll')}</td>
        {status !== 'in-progress' &&
        <td className="text-center">
          {buttonAction}
        </td>
        }
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Row/ReminderRow.js